import React from "react";

function Main() {
    return (
        <>
            <div className="hero-sec"></div>

            <div className="box">

                <div className="first">
                    <div className="child">
                        <h3 className="child-info">10+</h3>
                        <hr id="child-line" />
                        <p className="child-info" id="child-cont">number  of r&amp;d staff</p>
                    </div>

                    <div className="child ext" id="imp">
                        <h3 className="child-info in3">3+</h3>
                        <hr id="child-line" />
                        <p className="child-info" id="cer">certificate</p>
                    </div>
                </div>

                <div className="second">
                    <div className="child">
                        <h3 className="child-info">5+</h3>
                        <hr id="child-line" />
                        <p className="child-info" id="cer">production line</p>
                    </div>

                    <div className="child n-child" id="imp">
                        <h3 className="child-info" id="amo">1000000+</h3>
                        <hr id="child-line" />
                        <p className="child-info" id="amo">output value</p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Main